import { usingGet, usingPut, usingPost, usingDelete } from '@ocean/api'
import { BASE_API_SCHEDULE_PATH } from 'modules/virtualClassrooms/common/helpers'
import {
  AddVirtualEventWaitListPersonsModel,
  MoveParticipantsToPreferredScheduleModel,
  RemoveVirtualEventWaitListPersonsModel,
} from 'modules/virtualClassrooms/common/types/waitList'
import { EventEditorFormParams } from 'modules/virtualClassrooms/manager/EventDetails/types/eventEditor'

export const updateVirtualClassroomEvent = (eventId: Guid, params: EventEditorFormParams) =>
  usingPut(`VirtualEvents/UpdateVirtualEvent?eventId=${eventId}`, params)

export const deleteVirtualClassroomEvent = (eventId: Guid) =>
  usingDelete(`VirtualEvents/DeleteVirtualEvent?eventId=${eventId}`)

export const getListVirtualEventWaitListPersons = (eventId: Guid) =>
  usingGet(`virtualevents/event/${eventId}/waitlist`, { useProxy: true })

export const addVirtualEventWaitListPersons = (params: AddVirtualEventWaitListPersonsModel) =>
  usingPost(`VirtualEvents/AssignVirtualEventWaitListParticipants`, params)

export const moveParticipantsToPreferredSchedule = (
  params: MoveParticipantsToPreferredScheduleModel
) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/moveParticipantsToPreferredSchedule`, params, {
    useProxy: true,
  })

export const removeVirtualEventWaitListPersons = (params: RemoveVirtualEventWaitListPersonsModel) =>
  usingPost(`VirtualEvents/UnassignVirtualEventWaitListParticipants`, params)

export const publishVirtualClassroomEvent = (eventId: Guid) =>
  usingPost('VirtualEvents/PublishVirtualEvent', { eventId })
